import { Box } from "@mui/material";

/**
 * Globaler PWA-Hintergrund.
 * Verwendet exakt das vom Benutzer bereitgestellte Main-Background-Asset.
 * Auf schmalen Smartphone-Viewports wird das komplette Motiv bewusst auf den
 * Viewport skaliert, damit die seitlichen Industrie-Strukturen nicht durch
 * background-size: cover aus dem sichtbaren Ausschnitt verschwinden.
 */
export function GlobalIndustrialBackdrop() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        backgroundColor: "#121417",
        backgroundImage: 'url("/ui/main-background.png")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: { xs: "100% 100%", md: "cover" },
      }}
    />
  );
}

/**
 * Eigener, vom globalen Hintergrund bewusst getrennter Systemstatus-Hintergrund.
 * Verwendet exakt das vom Benutzer bereitgestellte Systemstatus-Asset.
 */
export function SystemStatusHarborBackdrop() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        backgroundColor: "#101215",
        backgroundImage: 'url("/ui/systemstatus-background.png")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center bottom",
        backgroundSize: "100% 100%",
      }}
    />
  );
}
